import { Component } from '@angular/core';

@Component({
  selector: 'app-simulation-message',
  templateUrl: './simulation-message.component.html',
  styleUrls: ['./simulation-message.component.scss'],
})
export class SimulationMessageComponent { }
